<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    @if (page) {
      <section>
        <div class="card">
          <div class="row">
            <div class="col-6">
              <div class="show-entries-container">
                <label
                  >Zeige
                  <ng-select
                    [clearable]="false"
                    [searchable]="false"
                    [formControl]="filter.get('limit') | formControl">
                    <ng-option [value]="10">10</ng-option>
                    <ng-option [value]="25">25</ng-option>
                    <ng-option [value]="50">50</ng-option>
                    <ng-option [value]="100">100</ng-option>
                  </ng-select>
                  Einträge</label
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="datatable-add-button">
                  <button
                    type="button"
                    rippleEffect
                    (click)="openModal()">
                    <i
                      data-feather="plus"
                      class="datatable-add-button-icon"></i
                      ><span class="datatable-add-button-text">Wohnung hinzufügen</span>
                    </button>
                  </div>
                </div>
              </div>
              <ngx-datatable
                [rows]="page.items"
                [reorderable]="false"
                rowHeight="auto"
                class="bootstrap core-bootstrap"
                columnMode="force"
                [scrollbarH]="true"
                [count]="page.totalItems ?? 0"
                [offset]="page.currentPage - 1"
                [limit]="page.itemsPerPage"
                [externalPaging]="true"
                (page)="setPage($event)"
                [externalSorting]="true"
                (sort)="onSort($event)">
                <ngx-datatable-column
                  [width]="75"
                  prop="id"
                  name=""
                  [sortable]="false">
                  <ng-template
                    let-value="value"
                    let-row="row"
                    ngx-datatable-cell-template>
                    <div class="datatable-buttons">
                      @if (!row.deletedAt){
                        <a
                          title="bearbeiten"
                          [routerLink]="[]"
                          [queryParams]="getOpenModalParams(value)"
                          class="clickable-icon">
                          <i data-feather="edit"></i>
                        </a>
                        <div
                          title="löschen"
                          class="clickable-icon-danger"
                          (click)="delete(value)">
                          <i data-feather="trash"></i>
                        </div>
                      } @else {
                        @if (CaslAction.Restore | permission: EntityTyp.Housing){
                          @if (row.deletedAt) {
                            <div class="datatable-buttons">
                              <div
                                title="Wiederherstellen"
                                class="clickable-icon"
                                (click)="restore(value)">
                                <i data-feather="plus-circle"></i>
                              </div>
                            </div>
                          }
                        }
                      }
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  prop="name"
                  name="Name">
                  <ng-template
                    let-column="column"
                    ngx-datatable-header-template
                    let-sort="sortFn"
                    let-sortDir="sortDir">
                    <love-it-list-header-cell
                      [column]="column"
                      [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                    <love-it-filter-input [filterFormControl]="filter.get('name') | formControl"></love-it-filter-input>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  prop="address"
                  name="Adresse">
                  <ng-template
                    let-column="column"
                    ngx-datatable-header-template
                    let-sort="sortFn"
                    let-sortDir="sortDir">
                    <love-it-list-header-cell
                      [column]="column"
                      [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                    <love-it-filter-input [filterFormControl]="filter.get('address') | formControl"></love-it-filter-input>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  prop="residents"
                  name="Bewohner:innen"
                  [sortable]="false">
                  <ng-template
                    let-value="value"
                    ngx-datatable-cell-template>
                    @for (resident of value; track resident.id; let last = $last) {
                      <a
                        [routerLink]="['/housing']"
                        [queryParams]="{ modalTyp: 'Client', modalEntityId: resident.id }"
                        queryParamsHandling="merge">
                        {{ resident.name + (last ? "" : ", ") }}
                      </a>
                    }
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  prop="office"
                  name="Standort">
                  <ng-template
                    let-column="column"
                    ngx-datatable-header-template
                    let-sort="sortFn"
                    let-sortDir="sortDir">
                    <love-it-list-header-cell
                      [column]="column"
                      [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                    <ng-select
                      [items]="offices"
                      [formControl]="filter.get('officeId') | formControl"
                      bindValue="id"
                    bindLabel="name"></ng-select>
                  </ng-template>
                </ngx-datatable-column>
                @if (authService.currentUserValue?.role === UserRole.Admin) {
                  <ngx-datatable-column
                    prop="deletedAt"
                    name="Gelöscht"
                    [sortable]="false">
                    <ng-template
                      let-column="column"
                      ngx-datatable-header-template
                      let-sort="sortFn"
                      let-sortDir="sortDir">
                      <love-it-list-header-cell
                        [column]="column"
                        [sortFunc]="sort"
                      [sortDir]="sortDir"></love-it-list-header-cell>
                      <love-it-select-boolean
                        [booleanFc]="filter.get('deleted') | formControl"
                      ></love-it-select-boolean>
                    </ng-template>
                    <ng-template
                      ngx-datatable-cell-template
                      let-value="value">
                      <love-it-display-boolean [value]="value"></love-it-display-boolean>
                    </ng-template>
                  </ngx-datatable-column>
                }
              </ngx-datatable>
            </div>
          </section>
        }
      </div>
    </div>
